import { useState, useEffect } from "react";
// import icon1 from "../assets/focus.png";
// import icon2 from "../assets/result.png";
// import icon3 from "../assets/team.png";
// import icon4 from "../assets/process.png";
// import icon5 from "../assets/focus.png";
// import icon6 from "../assets/team.png";
import "../styles/Credibility.css";

const credibilityItems = [
  {
    icon: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/focus.png?v=1765273103&width=100",
    title: "Exclusive Focus",
    text: "We only work with 3-4 clients per month to ensure exceptional results",
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/result.png?v=1765273198&width=100",
    title: "Proven Results",
    text: "50+ stores launched with 2-3x industry-average conversion rates",
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/team.png?v=1765273270&width=100",
    title: "Expert Team",
    text: "Certified Shopify developers with 5+ years of ecommerce experience",
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/process.png?v=1765273308&width=100",
    title: "Selective Process",
    text: "We choose projects where we can deliver transformational results",
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/market-analysis.png?v=1772854295&width=100",
    title: "Conversion-Driven Strategy",
    text: "Every store built using proven CRO methods to maximize sales.",
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/performance.png?v=1772854640&width=100",
    title: "Performance Optimized",
    text: "Fast, scalable Shopify stores optimized for speed, SEO, growth.",
  },
];

export default function Credibility() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      nextSlide();
    }
    if (touchStart - touchEnd < -75) {
      prevSlide();
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % credibilityItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + credibilityItems.length) % credibilityItems.length,
    );
  };

  return (
    <section className="credibility-section">
      <div className="credibility-container">
        <div className="credibility-header">
          <h2 className="credibility-title global-body-heading-fonts">
            Why Smart Brands Choose TechTCL Over Bigger Agencies
          </h2>
        </div>

        {/* Desktop Grid */}
        <div className="credibility-grid">
          {credibilityItems.map((item, index) => (
            <div key={index} className="credibility-item">
              <div className="credibility-icon">
                <img loading="lazy" src={item.icon} alt={item.title} width={56} height={56} />
              </div>
              <h3 className="credibility-item-title">{item.title}</h3>
              <p className="credibility-item-text">{item.text}</p>
            </div>
          ))}
        </div>

        {/* Mobile Slider */}
        <div
          className="credibility-slider"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className="credibility-slider-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {credibilityItems.map((item, index) => (
              <div key={index} className="credibility-slide">
                <div className="credibility-icon">
                  <img loading="lazy" src={item.icon} alt={item.title} width={56} height={56} />
                </div>
                <h3 className="credibility-item-title">{item.title}</h3>
                <p className="credibility-item-text">{item.text}</p>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
            onTouchEnd={(e) => e.stopPropagation()}
            className="slider-arrow slider-arrow-left"
            aria-label="Previous slide"
          >
            ‹
          </button>
          <button
            onClick={nextSlide}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
            onTouchEnd={(e) => e.stopPropagation()}
            className="slider-arrow slider-arrow-right"
            aria-label="Next slide"
          >
            ›
          </button>
        </div>

        {/* Navigation Dots */}
        <div className="slider-dots">
          {credibilityItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`slider-dot ${
                index === currentSlide ? "slider-dot-active" : ""
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
